<template>
    <div class="main">
        <div class="loading" v-if="status === 2">경기가 종료 되었습니다.</div>
        <div class="loading" v-else-if="status == 0">경기 시작 전입니다. 잠시 후 다시 시도해 주세요</div>
    </div>
</template>
  
<script>
export default {
    props: {
        status: {
            type: Number,
            required: true,
        },
    },
};
</script>
  
<style scoped>
.main {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 9999;
}
.loading {
    position: relative;
    min-width: 360px;
    height: 60px;
    font-size: 26px;
    color: rgb(200, 200, 200);
    line-height: 60px;
    background-color: rgba(0, 0, 0, 0.6);
    filter: brightness(1.75);
    border-radius: 0.4em;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 10px;
    display: inline-block;
}
</style>